export type { SimpleCardProps, SimpleCardContainerProps } from './SimpleCard.types'
export { default as SimpleCard } from './SimpleCard'
export { default as SimpleCardContainer } from './SimpleCardContainer'